const ProgressCard = ({ props }) => {
  return (
    <div className="progress-card">
      <div className="progress-card-header">
        <h3>{props.heading}</h3>
        <p>{props.emoji_icon}</p>
      </div>
      <img src={props.svg_img} alt="" />
      <div
        className={`${
          props.style === "center"
            ? "progress-card-data-center"
            : "progress-card-data-uncenter"
        } progress-card-data`}
      >
        <h3>{props.info_data}</h3>
        <p>{props.info_unit}</p>
      </div>
    </div>
  );
};
export const ProgressStats = (props) => {
  const { stats } = props;

  return (
    <div className="progress-cards">
      {stats.map((stat, index) => (
        <ProgressCard key={index} props={stat} />
      ))}
    </div>
  );
};
